import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-9xl font-extrabold text-[#504e9a]">404</h1>
        <p className="text-2xl md:text-3xl font-light text-gray-800 mt-4">
          Oops! The page you're looking for doesn't exist.
        </p>
        <p className="mt-2 text-gray-600">
          The page you are trying to reach might have been removed or is temporarily unavailable.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-block px-6 py-3 text-sm font-medium text-white bg-[#4898a5] rounded-lg shadow hover:bg-[#4898a5] focus:ring-2 focus:ring-[#4898a5] focus:ring-opacity-75"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
